module.exports = __webpack_public_path__ + "img/close.d14a2fc4.svg";